

	import { onMounted, ref, computed } from 'vue';
	import moment, { Moment } from 'moment';
	import { GetBlogsForProduct } from 'Apis/apis';
	import Swiper, { Navigation, Pagination } from 'swiper';	

	Swiper.use([Pagination, Navigation]);

	export default {
		name: 'BlogsDesktop',
		setup() {									
			const productData = ref(null);
			const blogs = ref([]);
			const selectedOption = ref('');
			const swiperWrapper = ref(null);
			const swiper = ref(null);
			const prevButton = ref(null);
			const nextButton = ref(null);
			const isHidden = ref(true);
			const translations = ref({});
			const currentCulture = document.body.getAttribute('data-current-culture');
			if (currentCulture == "pt") {
				moment.locale('pt-br'); // Ensures locale is set
			}
			else if (currentCulture == "en") {
				moment.locale('en');
			}
			else {
				moment.locale('es');
			}

			//GET PRODUCT ID FROM .NET PAGE
			let productId = document.querySelector('.js-blogs').getAttribute('data-product-id') ? document.querySelector('.js-blogs').getAttribute('data-product-id') : "";

			//GET Blogs FROM API
			async function getBlogs(productId) {
				isHidden.value = true;				
				const rspblogs = await GetBlogsForProduct(productId);
				let modifiedArray = [];
				let promises = [];								

				for (let [index, item] of rspblogs.value.entries()) {
					item.ImagePath = item.HomeImage[0]?.Url;
					item.Alt - item.HomeImage[0].AlternativeText;
					//item.pubFormattedDate = new Date(item.PublicationDate);
					if (currentCulture == "pt") {
						item.pubFormattedDate = moment(item.PublicationDate).format('ll');
					}
					else if (currentCulture == "en") {
						item.pubFormattedDate = moment(item.PublicationDate).format('MMM DD, YYYY');
					}
					else {
						item.pubFormattedDate = moment(item.PublicationDate).format('DD MMM , YYYY');
					}
					item.Title = item.Title.replace(/[®]/g, '<sup class="blog-reg">$&</sup>');
					item.Summary = item.Summary.replace(/[®]/g, '<sup class="blog-reg">$&</sup>');														
					modifiedArray.push(item);
					promises.push(new Promise((resolve) => {
						let img = new Image();
						img.onload = resolve;
						img.src = item.ImagePath;
						img.alt = item.Alt;
					}));
				}				
				blogs.value = modifiedArray;
				await Promise.all(promises);
				setupProductSetItemsSwiper();
				isHidden.value = false;
			}						

			let productSetItemsSwiper;

			//SETUP SWIPER
			let setupProductSetItemsSwiper = () => {
				//DESTROY SWIPER IF IT EXISTS ALREADY

				if (typeof productSetItemsSwiper !== 'undefined' && productSetItemsSwiper !== null) {
					productSetItemsSwiper.destroy();
					productSetItemsSwiper = null;
				}

				//REINITIALIZE SWIPER
				productSetItemsSwiper = new Swiper(swiper.value, {
					slidesPerView: 1,
					spaceBetween: 0,

					// Navigation arrows
					navigation: {
						nextEl: nextButton.value,
						prevEl: prevButton.value,
					},

					breakpoints: {
						0: {
							slidesPerView: 1,
							spaceBetween: 0,
						},
						768: {
							slidesPerView: 3,
							spaceBetween:4,
						}
					}
				});
			};

			onMounted(() => {
				const translationEl = document.querySelector('.js-blogs');
				const translationValue = translationEl.getAttribute('data-translations');
				if (translationEl && translationValue) {
					translations.value = JSON.parse(translationValue);
				}
				if (productId) {
					getBlogs(productId);
				}
			});

			return {
				blogs,
				productData,
				selectedOption,
				swiper,
				swiperWrapper,
				nextButton,
				prevButton,
				isHidden,
				translations
			};
		},
	};
